import React from 'react';

const clamp = (value, min, max) => {
    if (typeof value !== 'number' || Number.isNaN(value)) return min ?? 0;
    if (typeof min === 'number' && value < min) return min;
    if (typeof max === 'number' && value > max) return max;
    return value;
};

const parseNumberInput = (raw) => {
    if (raw === '' || raw === null || typeof raw === 'undefined') return null;
    const n = Number.parseInt(String(raw), 10);
    return Number.isNaN(n) ? null : n;
};

const QuantityStepper = ({
    value,
    onChange,
    min = 0,
    max,
    step = 1,
    disabled = false,
    disabledDecrement,
    disabledIncrement,
    inputAriaLabel = 'Quantity',
    decrementAriaLabel = 'Decrease quantity',
    incrementAriaLabel = 'Increase quantity',
    minusIcon = '−',
    plusIcon = '+',
    className = '',
    style,
    inputProps,
    buttonSize,
    inputWidth,
    iconSize,
}) => {
    const safeValue = typeof value === 'number' ? value : (value ?? 0);
    const decDisabled = disabled || (typeof disabledDecrement === 'boolean' ? disabledDecrement : safeValue <= min);
    const incDisabled = disabled || (typeof disabledIncrement === 'boolean' ? disabledIncrement : false);

    const commit = (next) => {
        const clamped = clamp(next, min, max);
        onChange?.(clamped);
    };

    const inputClassName = ['form-control', 'britge-qty-stepper__input', 'text-center', inputProps?.className].filter(Boolean).join(' ');
    const sizeStyle = {};
    if (buttonSize) {
        sizeStyle['--britge-qty-h'] = `${buttonSize}px`;
        sizeStyle['--britge-qty-btn'] = `${buttonSize}px`;
    }
    if (inputWidth) sizeStyle['--britge-qty-input'] = `${inputWidth}px`;
    if (iconSize) sizeStyle['--britge-qty-icon'] = `${iconSize}px`;

    return (
        <div
            className={`britge-qty-stepper ${className}`}
            style={{ ...sizeStyle, ...style }}
        >
            <button
                type="button"
                className="btn britge-qty-stepper__btn"
                aria-label={decrementAriaLabel}
                disabled={decDisabled}
                onClick={() => commit((safeValue || 0) - step)}
            >
                <span className="britge-qty-stepper__icon">
                    {minusIcon}
                </span>
            </button>
            <input
                type="number"
                inputMode="numeric"
                min={min}
                {...inputProps}
                className={inputClassName}
                aria-label={inputAriaLabel}
                value={safeValue || 0}
                disabled={disabled}
                onChange={(e) => {
                    const parsed = parseNumberInput(e.target.value);
                    if (parsed === null) return commit(min ?? 0);
                    commit(parsed);
                }}
            />
            <button
                type="button"
                className="btn britge-qty-stepper__btn"
                aria-label={incrementAriaLabel}
                disabled={incDisabled}
                onClick={() => commit((safeValue || 0) + step)}
            >
                <span className="britge-qty-stepper__icon">
                    {plusIcon}
                </span>
            </button>
        </div>
    );
};

export default QuantityStepper;



